const messages = {
  title: "Noin BS Plus",
  description: "About page description",
};

export default {
  messages,
};
